import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const soilTypeApi = createApi({
  reducerPath: 'soilTypeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSoilTypes: builder.query({
      query: () => `soil-types`,
    }),
    getSoilTypeById: builder.query({
      query: (id) => `soil-types/${id}`,
    }),
    postSoilType: builder.mutation({
      query: (newSoilType) => ({
        url: 'soil-types',
        method: 'POST',
        body: newSoilType,
      }),
    }),
    updateSoilType: builder.mutation({
      query: ({ id, updatedSoilType }) => ({
        url: `soil-types/${id}`,
        method: 'PUT',
        body: updatedSoilType,
      }),
    }),
    updateSoilTypeStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `soil-types/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
    }),
  }),
});

export const {
  useGetSoilTypesQuery,
  useGetSoilTypeByIdQuery,
  usePostSoilTypeMutation,
  useUpdateSoilTypeMutation,
  useUpdateSoilTypeStatusMutation,
} = soilTypeApi;
